export default "__VITE_ASSET__DE17JwCG__"